/**
 * Executes the first callback, if it not resolve within timeout the fallback
 * function will be called.
 * @param {Function} mainExecutor
 * @param {Function} fallbackExecutor
 * @param {Number} timeout
 * @returns {Promise}
 */
export const setTimeoutFallback = (mainExecutor, fallbackExecutor, timeout) => {
  const mainPromise = new Promise(mainExecutor)
  const fallbackPromise = new Promise((resolve, reject) => {
    setTimeout(() => {
      fallbackExecutor(resolve, reject)
    }, timeout)
  })

  return Promise.race([mainPromise, fallbackPromise])
}



// WEBPACK FOOTER //
// ./common/utils/async.js